import React from "react";
import { Link } from "react-router-dom";
import NotFoundImage from "../../Assets/404.gif";
import NotFoundImageBlue from "../../Assets/404_blue.svg";

const PageError = ({ pageError }) => {
  return (
    <>
      {/* Blue design for 404*/}

      <div className="fix d-flex flex-column align-items-center text-center px-4 gap-20 error-page pt-40px">
        <svg
          className="gift-icon-main"
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
        >
          {" "}
          <mask
            id="mask0_4382_58645"
            style={{ maskType: "luminance" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="80"
            height="80"
          >
            {" "}
            <path d="M80 0H0V80H80V0Z" fill="white" />{" "}
          </mask>{" "}
          <g mask="url(#mask0_4382_58645)">
            {" "}
            <path
              opacity="0.4"
              d="M66.5672 33.3333V60C66.5672 70 63.2339 73.3333 53.2339 73.3333H26.5672C16.5672 73.3333 13.2339 70 13.2339 60V33.3333H66.5672Z"
              fill="currentColor"
            />{" "}
            <path
              d="M71.6666 23.3333V26.6666C71.6666 30.3333 69.8999 33.3333 64.9999 33.3333H14.9999C9.89992 33.3333 8.33325 30.3333 8.33325 26.6666V23.3333C8.33325 19.6666 9.89992 16.6666 14.9999 16.6666H64.9999C69.8999 16.6666 71.6666 19.6666 71.6666 23.3333Z"
              fill="currentColor"
            />{" "}
            <path
              opacity="0.4"
              d="M38.7993 16.6648H20.3992C19.2659 15.4315 19.2992 13.5315 20.4992 12.3315L25.2325 7.59816C26.4659 6.36482 28.4992 6.36482 29.7325 7.59816L38.7993 16.6648Z"
              fill="currentColor"
            />{" "}
            <path
              opacity="0.4"
              d="M59.567 16.6648H41.167L50.2337 7.59816C51.467 6.36482 53.5003 6.36482 54.7337 7.59816L59.467 12.3315C60.667 13.5315 60.7003 15.4315 59.567 16.6648Z"
              fill="currentColor"
            />{" "}
            <path
              opacity="0.6"
              d="M29.7998 33.3333V50.4666C29.7998 53.1333 32.7331 54.7 34.9663 53.2666L38.0997 51.2C39.233 50.4666 40.6663 50.4666 41.7663 51.2L44.733 53.2C46.933 54.6666 49.8997 53.1 49.8997 50.4333V33.3333H29.7998Z"
              fill="currentColor"
            />{" "}
          </g>{" "}
        </svg>
        <svg className="gift-icon-main-first-reserve" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 68 60" fill="none">
          <path d="M29.7072 2.26954C31.4542 -0.756504 35.822 -0.75651 37.569 2.26953L66.6613 52.6588C68.4084 55.6848 66.2245 59.4674 62.7304 59.4674H4.54586C1.05169 59.4674 -1.13218 55.6848 0.614905 52.6588L29.7072 2.26954Z" fill="url(#paint0_linear_5250_23277)" />
          <path d="M29.7072 2.26954C31.4542 -0.756504 35.822 -0.75651 37.569 2.26953L66.6613 52.6588C68.4084 55.6848 66.2245 59.4674 62.7304 59.4674H4.54586C1.05169 59.4674 -1.13218 55.6848 0.614905 52.6588L29.7072 2.26954Z" fill="url(#paint1_linear_5250_23277)" />
          <path d="M31.9071 6.07488C32.6759 4.74342 34.5977 4.74343 35.3664 6.07488L62.2626 52.6606C63.0314 53.9921 62.0705 55.6564 60.533 55.6564H6.74048C5.20304 55.6564 4.24215 53.9921 5.01087 52.6606L31.9071 6.07488Z" fill="#F4E8AF" />
          <circle cx="33.6399" cy="37.7205" r="12.3713" fill="#D54452" stroke="white" stroke-width="1.1893" />
          <path d="M35.7161 29.9971L35.3299 40.4537H31.9434L31.5572 29.9971H35.7161ZM33.6366 45.4443C33.0623 45.4443 32.5697 45.2438 32.1587 44.8428C31.7528 44.4368 31.5522 43.9441 31.5572 43.3649C31.5522 42.8004 31.7528 42.3177 32.1587 41.9167C32.5697 41.5157 33.0623 41.3151 33.6366 41.3151C34.1812 41.3151 34.6615 41.5157 35.0774 41.9167C35.4982 42.3177 35.7111 42.8004 35.7161 43.3649C35.7111 43.751 35.6096 44.1026 35.4116 44.4194C35.2185 44.7314 34.966 44.9814 34.6541 45.1695C34.3421 45.3527 34.003 45.4443 33.6366 45.4443Z" fill="white" />
          <defs>
            <linearGradient id="paint0_linear_5250_23277" x1="33.638" y1="-4.53906" x2="33.638" y2="80.8029" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F6D978" />
              <stop offset="1" stop-color="#E4BA3F" />
            </linearGradient>
            <linearGradient id="paint1_linear_5250_23277" x1="37.4578" y1="12.336" x2="35.7898" y2="69.1626" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F0B915" />
              <stop offset="1" stop-color="#F1913D" />
            </linearGradient>
          </defs>
        </svg>
        <div className="error-text-500">{pageError?.StatusCode}</div>
        <h4 className="server_error">{pageError?.ErrorName}</h4>
        <p className="error_description">{pageError?.ErrorDescription}</p>
        <div className="backbtnContainer">
          <Link className="back-to-home-btn" to={pageError?.url}>
            {pageError?.buttonText}
          </Link>
        </div>
      </div>
    </>
  );
};

export default PageError;
